const BACK_CUSTOM_ACTION =
    'GIL001: El usuario ha pulsado el botón de volver atrás de la cabecera del onboarding',
  DROP_MODAL_CUSTOM_ACTION =
    'GIL002: El usuario ha pulsado el boton de volver y se le ha enseñado el modal de drop',
  POP_STATE_CUSTOM_ACTION =
    'GIL003: El evento pop state ha sido lanzado, eso significa que puede ser que el usuario le haya dado a back en el navegador',
  UNLOAD_CUSTOM_ACTION =
    'El navegador esta saliendo del dominio del onboarding, bien sea cerrando webview o volviendo a amazon';

export {
  BACK_CUSTOM_ACTION,
  DROP_MODAL_CUSTOM_ACTION,
  POP_STATE_CUSTOM_ACTION,
  UNLOAD_CUSTOM_ACTION,
};
